import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useNavData } from '@/contexts/NavContext';
import styles from './style.module.less';

function SiteLayout() {
  const { navData } = useNavData();

  return (
    <div className={styles.layout}>
      <Header data={navData} />
      <div className={styles.main}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default SiteLayout;
